import { c as _c } from "react/compiler-runtime";
import type { Address } from 'viem';
import { getChainAddresses } from '@morpho-org/blue-sdk';
import { vaultV2FactoryAbi } from '@morpho-org/blue-sdk-viem';
import { isDefined } from '@morpho-org/morpho-ts';
import { useReadContract } from 'wagmi';
import { useWeb3Context } from '@/contexts/Web3Context';
import { useChangeAfterFetching } from '@/hooks/useChangeAfterFetching';
export function useVaultV2FactoryCheck(t0) {
  const $ = _c(19);
  const {
    vaultAddress,
    enabled: t1
  } = t0;
  const enabled = t1 === undefined ? true : t1;
  const {
    targetChainId,
    account
  } = useWeb3Context();
  let t2;
  let t3;
  let vaultV2Factory;
  if ($[0] !== account || $[1] !== enabled || $[2] !== targetChainId) {
    ({
      vaultV2Factory
    } = getChainAddresses(targetChainId));
    t3 = useReadContract;
    t2 = isDefined(vaultV2Factory) && account.isConnected && enabled;
    $[0] = account;
    $[1] = enabled;
    $[2] = targetChainId;
    $[3] = t2;
    $[4] = t3;
    $[5] = vaultV2Factory;
  } else {
    t2 = $[3];
    t3 = $[4];
    vaultV2Factory = $[5];
  }
  let t4;
  if ($[6] !== t2) {
    t4 = {
      enabled: t2,
      staleTime: Infinity
    };
    $[6] = t2;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== vaultAddress) {
    t5 = [vaultAddress];
    $[8] = vaultAddress;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4 || $[11] !== t5 || $[12] !== targetChainId || $[13] !== vaultV2Factory) {
    t6 = {
      query: t4,
      chainId: targetChainId,
      abi: vaultV2FactoryAbi,
      address: vaultV2Factory,
      functionName: "isVaultV2",
      args: t5
    };
    $[10] = t4;
    $[11] = t5;
    $[12] = targetChainId;
    $[13] = vaultV2Factory;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  const {
    data: isCorrectVaultV2,
    isLoading,
    isFetching,
    error
  } = t3(t6);
  const memoizedError = useChangeAfterFetching(error, isFetching);
  let t7;
  if ($[15] !== isCorrectVaultV2 || $[16] !== isLoading || $[17] !== memoizedError) {
    t7 = {
      isCorrectVaultV2,
      isLoading,
      error: memoizedError
    };
    $[15] = isCorrectVaultV2;
    $[16] = isLoading;
    $[17] = memoizedError;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
}